import { defHttp } from '@/utils/http/axios';

enum Api {
  // 多语言配置相关接口
  getAllMultilingualConfig = '/sys/multilingualConfig/getAllConfig',
  getMultilingualConfigByCode = '/sys/multilingualConfig',
  queryByConfigCode = '/sys/multilingualConfig/queryByConfigCode',
  addMultilingualConfig = '/sys/multilingualConfig/add',
  updateMultilingualConfig = '/sys/multilingualConfig/edit',
}

/**
 * 获取所有多语言配置
 */
export const getAllMultilingualConfig = () => {
  return defHttp.get({
    url: Api.getAllMultilingualConfig,
  });
};

/**
 * 根据配置代码获取多语言配置
 * @param configCode 配置代码
 */
export const getMultilingualConfigByCode = (configCode: string) => {
  return defHttp.get({
    url: `${Api.getMultilingualConfigByCode}/${configCode}`,
  });
};

export const queryMultilingualByConfigCode = (configCode: string) => {
  return defHttp.get({
    url: Api.queryByConfigCode,
    params: { configCode },
  });
};

/**
 * 新增多语言配置
 */
export const addMultilingualConfig = (data: any) => {
  return defHttp.post({
    url: Api.addMultilingualConfig,
    data,
  });
};

/**
 * 更新多语言配置
 */
export const updateMultilingualConfig = (data: any) => {
  return defHttp.put({
    url: Api.updateMultilingualConfig,
    data,
  });
};
